module.exports = __webpack_public_path__ + "img/search.41f9e822.svg";